var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIconParagraphDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_461)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.07831C3.90112 1.07831 0.578313 4.40112 0.578313 8.5C0.578313 12.5989 3.90112 15.9217 8 15.9217C12.0989 15.9217 15.4217 12.5989 15.4217 8.5C15.4217 4.40112 12.0989 1.07831 8 1.07831ZM0 8.5C0 4.08172 3.58172 0.5 8 0.5C12.4183 0.5 16 4.08172 16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5Z",
    fill: "#660019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9219 4.95523C12.026 4.85109 12.026 4.68224 11.9219 4.5781C11.8178 4.47397 11.6489 4.47397 11.5448 4.5781L8 8.12288L4.45523 4.5781C4.35109 4.47397 4.18224 4.47397 4.0781 4.5781C3.97397 4.68224 3.97397 4.85109 4.0781 4.95523L7.62288 8.5L4.0781 12.0448C3.97397 12.1489 3.97397 12.3178 4.0781 12.4219C4.18224 12.526 4.35109 12.526 4.45523 12.4219L8 8.87712L11.5448 12.4219C11.6489 12.526 11.8178 12.526 11.9219 12.4219C12.026 12.3178 12.026 12.1489 11.9219 12.0448L8.37712 8.5L11.9219 4.95523Z",
    fill: "#660019"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIconParagraphDark);
export default __webpack_public_path__ + "static/media/errorIconParagraphDark.74ad5bcfb1208e48270869ca2377a896.svg";
export { ForwardRef as ReactComponent };